module.exports = __webpack_public_path__ + "img/comments.da3873f4.svg";